document.addEventListener('DOMContentLoaded', function() {
  // Elements
  const form = document.getElementById('custom-product-form');
  const submitBtn = document.getElementById('submit-btn');
  const statusDiv = document.getElementById('status');
  const imageUpload = document.getElementById('image-upload');
  const imagePreview = document.getElementById('image-preview');
  const additionalImageUpload = document.getElementById('additional-image');
  const additionalImagePreview = document.getElementById('additional-image-preview');

  // Handle image preview
  function setupImagePreview(inputElement, previewElement) {
    inputElement.addEventListener('change', function() {
      const file = this.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = function(e) {
          previewElement.innerHTML = '';
          const img = document.createElement('img');
          img.src = e.target.result;
          previewElement.appendChild(img);
        }
        reader.readAsDataURL(file);
      } else {
        previewElement.innerHTML = '<p class="no-image">No image selected</p>';
      }
    });
  }

  // Setup image previews
  setupImagePreview(imageUpload, imagePreview);
  setupImagePreview(additionalImageUpload, additionalImagePreview);

  // Handle select color change
  const selects = document.querySelectorAll('.select-wrapper select');
  selects.forEach(select => {
    select.addEventListener('change', function() {
      this.style.color = this.value !== '' ? '#000000' : '#bdbdbd';
    });
    if (select.value === '') {
      select.style.color = '#bdbdbd';
    } else {
      select.style.color = '#000000';
    }
  });

  // Form submission
  form.addEventListener('submit', async function(e) {
    e.preventDefault();

    // 禁用按钮并添加加载动画
    submitBtn.disabled = true;
    submitBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Processing...';
    statusDiv.textContent = 'Uploading images...';
    statusDiv.style.backgroundColor = '#fff3cd';
    statusDiv.style.color = '#856404';

    // Get form data
    const nailShape = document.getElementById('nail-shape').value;
    const nailLength = document.getElementById('nail-length').value;
    const nailBedWidth = document.getElementById('nail-bed-width').value;
    const quantity = document.getElementById('quantity').value;
    const designDetails = document.getElementById('design-details').value;
    const imageFile = imageUpload.files[0];
    const additionalImageFile = additionalImageUpload.files[0];
    const phone = document.getElementById('phone').value;
    const socialMedia = document.getElementById('social-media').value;

    try {
      // 并行上传图片
      const uploadPromises = [];
      
      // Upload main image
      const mainImagePromise = (async () => {
        const formData = new FormData();
        formData.append('image', imageFile);
        const uploadResponse = await fetch('https://file.hnycyl.cn/index.php', {
          method: 'POST',
          body: formData
        });
        const uploadData = await uploadResponse.json();
        if (!uploadData.url) {
          throw new Error(uploadData.error || 'Unknown error');
        }
        return uploadData.url;
      })();

      uploadPromises.push(mainImagePromise);

      // Upload additional image (optional)
      let additionalImageUrl = '';
      if (additionalImageFile) {
        const additionalImagePromise = (async () => {
          const additionalFormData = new FormData();
          additionalFormData.append('image', additionalImageFile);
          const additionalResponse = await fetch('https://file.hnycyl.cn/index.php', {
            method: 'POST',
            body: additionalFormData
          });
          const additionalData = await additionalResponse.json();
          if (additionalData.url) {
            return additionalData.url;
          }
          console.warn('Failed to upload additional image:', additionalData.error || 'Unknown error');
          return '';
        })();
        uploadPromises.push(additionalImagePromise);
      }

      // 等待所有图片上传完成
      const [imageUrl, additionalUrl] = await Promise.all(uploadPromises);
      additionalImageUrl = additionalUrl || '';

      // 更新状态
      statusDiv.textContent = 'Preparing cart...';

      // Build Shopify cart properties
      const properties = {
        'Nail Shape': nailShape,
        'Nail Length': nailLength,
        'Nail Bed Width': nailBedWidth,
        'Quantity': quantity,
        'Design Details': designDetails,
        'Uploaded Image': imageUrl
      };
      if (additionalImageUrl) properties['Additional Image'] = additionalImageUrl;
      if (phone) properties['Phone'] = phone;
      if (socialMedia) properties['Social Media'] = socialMedia;

      // Clear the cart
      const clearResponse = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      if (!clearResponse.ok) {
        throw new Error('Failed to clear cart');
      }

      // Add to cart
      statusDiv.textContent = 'Adding to cart...';
      const cartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: 50988672876858,
            quantity: 1,
            properties: properties
          }]
        })
      });
      if (!cartResponse.ok) {
        throw new Error('Failed to add to cart');
      }

      // Success
      statusDiv.textContent = 'Success! Redirecting to checkout...';
      statusDiv.style.backgroundColor = '#d4edda';
      statusDiv.style.color = '#155724';
      submitBtn.innerHTML = '<i class="fa-solid fa-check"></i> Done';

      // 立即跳转（移除 1.5 秒延迟，或缩短为 500ms）
      setTimeout(() => {
        window.location.href = '/checkout';
      }, 500);

    } catch (error) {
      // Display error
      statusDiv.textContent = `Error: ${error.message}. Please try again.`;
      statusDiv.style.backgroundColor = '#f8d7da';
      statusDiv.style.color = '#721c24';
      submitBtn.disabled = false;
      submitBtn.innerHTML = '<i class="fa-solid fa-credit-card"></i> Checkout Now';
    }
  });
});